if (!window.dAgency) window.dAgency = {};

window.dAgency.initAccordions = () => {
  class Accordion {
    constructor(el) {
      this.el = el;
      this.verticalSpacing = parseFloat(getComputedStyle(el).paddingTop.replace('px', '')) + parseFloat(getComputedStyle(el).paddingBottom.replace('px', '')) + parseFloat(getComputedStyle(el).borderTopWidth.replace('px', '')) + parseFloat(getComputedStyle(el).borderBottomWidth.replace('px', ''));
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion-content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      if (!this.el.dataset.index) {
        this.el.dataset.index = new Date().getTime();
      }
      this.dataIndex = this.el.dataset.index;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      if (!this.isClosing && !this.isExpanding) {
        this.el.style.overflow = 'hidden';
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.verticalSpacing}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 800,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      if (this.el.classList.contains('filter__disclosure')) {
        $('details.filter__disclosure[open]:not([data-index="' + this.dataIndex + '"]) summary').trigger('click');
      }
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight + this.verticalSpacing}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      if (this.el.classList.contains('filter__disclosure')) {
        $('details.filter__disclosure:not([data-index="' + this.dataIndex + '"]) summary').css('pointer-events', 'none');
      }
      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';

      if (this.el.classList.contains('filter__disclosure')) {
        $('details.filter__disclosure:not([data-index="' + this.dataIndex + '"]) summary').css('pointer-events', '');
      }
    }
  }

  document.querySelectorAll('details').forEach((el) => {
    if (el.querySelector('summary') && el.querySelector('.accordion-content')) {
      new Accordion(el);
    }
  });
}

window.dAgency.initAccordions();
